import { combineReducers } from 'redux'
import { reducer as firebase } from 'react-redux-firebase'
import { reducer as form } from 'redux-form'
import { reducer as notifications } from 'modules/notification'
import locationReducer from './location'

let PresupuestoParticipativo = () => {
  return {
    nameProject:'',
    folio:'',
    saveProject:{
      form:true,
      documents:false,
      find:true,
      formsGeneral:false
    },
    messageAlertDocuments:'',
    documents:[],
    mapProyect: new Map(),
    collectionProyect: [],
    createdAt: new Date()
  }
};


export function makeRootReducer(asyncReducers) {
  return combineReducers({
    // Add sync reducers here
    firebase,
    form,
    notifications,
    location: locationReducer,
    ...asyncReducers,
    PresupuestoParticipativo,
  })
}

export function injectReducer(store, { key, reducer }) {
  store.asyncReducers[key] = reducer // eslint-disable-line no-param-reassign
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
